import { ArrowIcon } from "./ArrowIcon";
import { CREATE_ACCOUNT_HREF } from "./constants";
import { Setup, SetupCopy, SetupSteps } from "./styles";

export function GettingStarted() {
  return (
    <Setup id="getting-started" aria-labelledby="setup-title">
      <SetupCopy>
        <h2 id="setup-title">
          A clearer picture starts with your first account.
        </h2>
        <p>
          No bank connection required. Add your balances and record your
          activity manually, then return to a view you can keep up to date.
        </p>
        <a href={CREATE_ACCOUNT_HREF}>
          Start with what you have today <ArrowIcon />
        </a>
      </SetupCopy>
      <SetupSteps>
        <li>
          <h3>Add your accounts.</h3>
          <p>
            Bring bank balances, savings, investments, and liabilities into one
            place.
          </p>
        </li>
        <li>
          <h3>Record your activity.</h3>
          <p>
            Add income and expenses, and organize the categories behind your
            spending.
          </p>
        </li>
        <li>
          <h3>Return to the bigger picture.</h3>
          <p>
            Follow your financial history and progress toward savings goals.
          </p>
        </li>
      </SetupSteps>
    </Setup>
  );
}
